import React, { Component } from 'react';
import Mapir from "mapir-react-component";

import mapMarker from '../../../../assets/icons/mapMarker.svg';

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg1MmU4MzJkMTliNzZkNTBlMzY4ZWRlODBlNDcxMDE1ODRmZDM3Y2EwODUxYWNjMWNjN2Y3NjQ2MTk5ZDE5ZTY3Y2NmNTI3Y2M1YzQyYmYwIn0.eyJhdWQiOiIxMjcyMCIsImp0aSI6Ijg1MmU4MzJkMTliNzZkNTBlMzY4ZWRlODBlNDcxMDE1ODRmZDM3Y2EwODUxYWNjMWNjN2Y3NjQ2MTk5ZDE5ZTY3Y2NmNTI3Y2M1YzQyYmYwIiwiaWF0IjoxNjEyODY5NDg3LCJuYmYiOjE2MTI4Njk0ODcsImV4cCI6MTYxNTM3NTA4Nywic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.g2yX_hpV19e380jvsp2NMDahS01ptf4DOim9CudsMP1MGWrWD0qpobn6dK6phFx8aeDgE7pLWlZeTXAfkeiFH_1qZKIoYG84xrYpr2dZ6_c3hw-4FVyYb8YaSP6cdIDlGob8cfjpbBxZfVf01g0FOXrZdo0trNCsau4HHZtVRJE7Ef72icebtHIyEYWXuB8hnD13PgUWziFicwIoLQeMSE1lBMgKrSHM-0tvvZQahF35tUyiPKo50PTOltcvhcJ3KhTlrhA-fVmtIX2n4OA7UOOaXBDviRZqDs_lN1S_bAFUQIX8gpQBbgSVwkYR1kxAqpl3Qp6Y298ZfKjvDmEonQ', //Mapir access token
        'Mapir-SDK': 'reactjs'
      }
    }
  }
})


export default class MapSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: [51.3810107, 35.7484547],
      zoom: [8],
      markerCoordinates: [51.3810107, 35.7484547],
    }
  }
  render() {
    return (
      <div className="mobile-duties__map d-flex flex-column" style={{ height: '250px' }}>
        <h2>مکان</h2>
        <Mapir Map={Map} center={this.state.center} zoom={this.state.zoom} apiKey={'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg1MmU4MzJkMTliNzZkNTBlMzY4ZWRlODBlNDcxMDE1ODRmZDM3Y2EwODUxYWNjMWNjN2Y3NjQ2MTk5ZDE5ZTY3Y2NmNTI3Y2M1YzQyYmYwIn0'} />
      </div >
    );
  }
}

